module.exports = __webpack_public_path__ + "static/media/chart-line-down.3e8db014.svg";